import $ from "jquery";
import _ from "underscore";
import { FormHelpersService } from "./FormHelpersService";

const AddToFormDirective = function ($timeout, $interpolate, FormHelpers: FormHelpersService) {
    //This should be used when you add inputs to a form dynamically through ng-include or via a directive.
    //If you don't use this then validation will NOT work as the form does not know anything about the element just added in terms of validation.
    return {
        restrict: "A",
        require: "ngModel",
        link: function (scope, element, attrs, controller: ng.INgModelController) {
            var modelController = controller;
            const formName = $interpolate(attrs.formName)(scope);

            $timeout(function () {
                // Escape any special characters (e.g. ".") from the specified form name, to avoid 
                // incurring errors when names are prefixed with "$ctrl.", as part of following the 
                // "controllerAs" pattern.
                const escapedFormName = $.escapeSelector(formName);
                const formElementParentScope = element.parents("form[name={0}]".format(escapedFormName)).first().scope();

                let formController = FormHelpers.getCtrlFormController(formElementParentScope, formName);
                if (!formController &&
                    formElementParentScope
                ) {
                    formController = formElementParentScope[formName];
                }

                if (!formController) {
                    throw "No parent form could be found with the name {0}".format(formName);
                }

                formController.$addControl(modelController)
                modelController.$validate();

                element.on("$destroy", function () {
                    //Clean up the removed element from the form
                    if (formController) {
                        formController.$removeControl(modelController);
                    }
    
                    element.off("$destroy");
                });
            });
        }
    }
};

AddToFormDirective.$inject = ["$timeout", "$interpolate", "FormHelpers"];

export { AddToFormDirective };